(function () {
  // Susivesk savo kainas čia:
  const PRICES = [
    { match: /Omniva paštomatas/i, price: "€4.59" },
    { match: /LP Express paštomatas/i, price: "€3.49" },
    { match: /DPD Lietuva paštomatas/i, price: "€4.49" },
  ];

  function addPrices() {
    // Ieškom Parcelly pasirinkimų teksto mazgų (dažniausiai label/span)
    const root = document.querySelector("body");
    if (!root) return;

    const labels = Array.from(root.querySelectorAll("label, span, div, p"))
      .filter(el => el.childElementCount === 0) // tik tekstiniai
      .filter(el => el.textContent && el.textContent.trim().length > 0);

    let changed = 0;

    for (const el of labels) {
      const txt = el.textContent.trim();

      for (const rule of PRICES) {
        if (rule.match.test(txt) && !txt.includes("€")) {
          el.textContent = `${txt} — ${rule.price}`;
          changed++;
        }
      }
    }

    return changed;
  }

  // Bandom iš karto ir kelis kartus, nes widgetas užsikrauna vėliau
  let tries = 0;
  const timer = setInterval(() => {
    tries++;
    const changed = addPrices();
    if ((changed && changed > 0) || tries > 30) clearInterval(timer);
  }, 300);

  // Ir dar: stebim DOM pokyčius (kai keiti metodą, persikrauna)
  const obs = new MutationObserver(() => addPrices());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

